import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startDemo } from "./api/client";
import { demoAsked, leaveDemo } from "./lib/demo";
import "./styles/index.css";

// The app lived under /app for a while; an address from then opens the same screen at the root.
const { pathname, search, hash } = window.location;
if (pathname === "/app" || pathname.startsWith("/app/")) {
  window.history.replaceState(null, "", `${pathname.slice("/app".length) || "/"}${search}${hash}`);
}

const root = document.getElementById("root");
if (!root) throw new Error("index.html has no #root");
const container = root;

async function boot() {
  // The sample workspace is loaded only by a tab that asked for it, before any request goes out.
  if (demoAsked()) {
    const { demoTransport } = await import("../mock/browser.ts");
    startDemo(demoTransport(leaveDemo));
  }
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
